import React from 'react';
import { useUIDSeed } from 'react-uid';
import { Text } from '..';
import { useCalendarManager } from './useCalendarManager';
import styles from './date-picker.module.css';
export const WeekDays = () => {
    const { days: { list } } = useCalendarManager();
    const seed = useUIDSeed();
    return React.createElement(React.Fragment, null, list().map((day) => (React.createElement(Text, { size: 14, textAlign: 'center', key: seed(day), className: styles.weekDay },
        React.createElement("abbr", { title: day.title }, day.abbr)))));
};
